.mat-mdc-input-element{vertical-align:initial}
/*# sourceMappingURL=decimal-number.component-AXQYRBT5.css.map */
